import { styled } from '@mui/material';

import { mainPreviewContainerStyles } from '~/styles/common';

export const StyledMockupWrapper = styled('div')({
  ...mainPreviewContainerStyles,
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
});
